import { render, staticRenderFns } from "./ProfitsharingRecord.vue?vue&type=template&id=3648d874&scoped=true"
import script from "./ProfitsharingRecord.vue?vue&type=script&lang=js"
export * from "./ProfitsharingRecord.vue?vue&type=script&lang=js"
import style0 from "./ProfitsharingRecord.vue?vue&type=style&index=0&id=3648d874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648d874",
  null
  
)

export default component.exports